import { styled, useStyletron } from '@tigergraph/app-ui-lib/Theme';
import Logo from '@/pages/home/logo';
import { useAtomValue } from 'jotai';
import { onboardingAtom } from '@/pages/onboarding/state';
import { useNavigate } from 'react-router-dom';
import IconButton from '@/components/IconButton';
import { X } from 'lucide-react';

export function TopSection({ hideBorder, showClose }: { hideBorder?: boolean; showClose?: boolean }) {
  const [css, theme] = useStyletron();
  const navigate = useNavigate();
  const { workspace } = useAtomValue(onboardingAtom);
  return (
    <div
      className={css({
        borderBottom: hideBorder ? 'none' : `1px solid ${theme.colors['border.tertiary']}`,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '16px',
        background: theme.colors['background.primary'],
        position: 'relative',
      })}
    >
      <Logo alwaysShow />
      {showClose && workspace && (
        <div
          className={css({
            position: 'absolute',
            right: '16px',
            top: '16px',
          })}
        >
          <IconButton
            aria-label="Close onboarding"
            onClick={() => navigate(`/groups/${workspace.workgroup_id}?workspace_id=${workspace.workspace_id}`)}
            title="Close"
          >
            <X width={20} height={20} />
          </IconButton>
        </div>
      )}
    </div>
  );
}

export const BottomSectionContainer = styled('div', ({ $theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '16px',
  alignItems: 'center',
  padding: '16px 24px',
  borderTop: `1px solid ${$theme.colors['border.tertiary']}`,
  background: $theme.colors['background.primary'],
}));

export const PageContainer = styled('div', ({ $theme }) => ({
  height: '100vh',
  width: '100vw',
  display: 'flex',
  flexDirection: 'column',
}));

export const MainScrollArea = styled('div', ({ $theme }) => ({
  flexGrow: 1,
  flexBasis: 0,
  overflowY: 'auto',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px 24px 0',
  gap: '18px',
}));
